import MuiTab, { TabProps } from '@mui/material/Tab';
import MuiTabs, { TabsProps } from '@mui/material/Tabs';

const Tabs: React.FC<TabsProps> = ({
  textColor,
  indicatorColor,
  sx,
  ...props
}) => {
  const styles = !textColor &&
    !indicatorColor && {
      '&&& .MuiTabs-indicator': {
        backgroundColor: 'primary.ogSmart',
      },
      '&&& .Mui-selected': {
        color: 'primary.ogSmart',
      },
    };

  return (
    <MuiTabs
      // MUI hides scroll buttons below the sm breakpoint by default, which
      // overrides scrollButtons="auto" and leaves overflowing tabs on mobile
      // with no visible affordance.
      allowScrollButtonsMobile
      sx={[styles, ...(Array.isArray(sx) ? sx : [sx])]}
      textColor={textColor}
      indicatorColor={indicatorColor}
      {...props}
    ></MuiTabs>
  );
};

const Tab: React.FC<TabProps> = ({ ...props }) => {
  return <MuiTab {...props}></MuiTab>;
};

export { Tabs, Tab };
